<div class="page-layout carded fullwidth">
  <div class="center">
    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
      <span class="h1" [translate]="'STORAGE_MOVEMENTS_REPORT.TITLE'"> Dashboard </span>

      <div class="page-buttons" fxHide.xs>
        <mat-slide-toggle
          labelPosition="before"
          matTooltip="{{ 'STORAGE_MOVEMENTS_REPORT.AUTORELOAD_TIME' | translate }}"
          (change)="updateAutoRefreshState({ enabled: $event.checked })"
          [checked]="false"
        >
          {{ 'STORAGE_MOVEMENTS_REPORT.AUTORELOAD' | translate }}
        </mat-slide-toggle>

        <button
          mat-stroked-button
          matTooltip="{{ 'STORAGE_MOVEMENTS_REPORT.RELOAD' | translate }}"
          (click)="reload()"
          [disabled]="isLoading"
        >
          <i class="angularjs-fuse-icon icon-reload small"></i>
        </button>

        <button
          *ngIf="isFilterOn"
          mat-stroked-button
          matTooltip="{{ 'STORAGE_MOVEMENTS_REPORT.FILTERS.CLEAR' | translate }}"
          [disabled]="isLoading"
          (click)="clearFilters()"
        >
          <i class="angularjs-fuse-icon icon-filter-remove"></i>
        </button>
      </div>

      <div class="page-buttons" fxShow="false" fxShow.xs>
        <button mat-stroked-button [matMenuTriggerFor]="menuDashboard">
          <mat-icon class="accent-500-fg">keyboard_arrow_down</mat-icon>
        </button>

        <mat-menu #menuDashboard>
          <button mat-menu-item fxLayout="row" fxLayoutAlign="start center" (click)="reload()" [disabled]="isLoading">
            <i class="angularjs-fuse-icon icon-reload small mr-4"></i>
            <span [translate]="'STORAGE_MOVEMENTS_REPORT.RELOAD'">Reload</span>
          </button>

          <button
            *ngIf="isFilterOn"
            mat-menu-item
            fxLayout="row"
            fxLayoutAlign="start center"
            (click)="clearFilters()"
            [disabled]="isLoading"
          >
            <i class="angularjs-fuse-icon icon-filter-remove small mr-4"></i>
            <span [translate]="'STORAGE_MOVEMENTS_REPORT.FILTERS.CLEAR'">Clear filters</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="dashboard">
      <div class="filter">
        <div class="filter__header" [class.expanded]="isFilterExpanded" (click)="isFilterExpanded = !isFilterExpanded">
          <div class="filter__header-title">
            <mat-icon class="filter__header-title__icon">filter_alt</mat-icon>
            {{ 'STORAGE_MOVEMENTS_REPORT.FILTERS.TITLE' | translate }}
          </div>

          <div class="filter__header-expand">
            {{
              (isFilterExpanded
                ? 'STORAGE_MOVEMENTS_REPORT.FILTERS.SEE_LESS'
                : 'STORAGE_MOVEMENTS_REPORT.FILTERS.SEE_MORE'
              ) | translate
            }}
          </div>
        </div>
        <div class="filter__content" *ngIf="isFilterExpanded">
          <div class="filter__content-gap-column">
            <div class="filter__content-row">
              <div class="row__item">
                <fc-product-input [control]="filterForm.get('product')" [preloadOptions]="true"></fc-product-input>
                <fc-storages-input [control]="filterForm.get('storages')"></fc-storages-input>
                <fc-date-input
                  [label]="'STORAGE_MOVEMENTS_REPORT.FILTERS.FROM' | translate"
                  [control]="filterForm.get('from')"
                  [placeholder]="'STORAGE_MOVEMENTS_REPORT.FILTERS.DATE_PLACEHOLDER' | translate"
                  translateErrorPrefix="STORAGE_MOVEMENTS_REPORT.ERRORS"
                  [max]="filterForm.get('to').value"
                ></fc-date-input>
                <fc-date-input
                  [label]="'STORAGE_MOVEMENTS_REPORT.FILTERS.UNTIL' | translate"
                  [control]="filterForm.get('to')"
                  [placeholder]="'STORAGE_MOVEMENTS_REPORT.FILTERS.DATE_PLACEHOLDER' | translate"
                  translateErrorPrefix="STORAGE_MOVEMENTS_REPORT.ERRORS"
                  [min]="filterForm.get('from').value"
                ></fc-date-input>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="dashboard__card">
        <div class="dashboard__card__situation">
          <fc-data-card-v2
            [label]="'STORAGE_MOVEMENTS_REPORT.TYPES.CARDS.ENTRY' | translate"
            [value]="movementsByType.entryCount"
            [loading]="isLoading"
            color="#29A37A"
            backgroundColor="#29A37A1A"
            icon="arrow_downward"
          >
          </fc-data-card-v2>
          <fc-data-card-v2
            [label]="'STORAGE_MOVEMENTS_REPORT.TYPES.CARDS.REMOVAL' | translate"
            [value]="movementsByType.removeCount"
            [loading]="isLoading"
            color="#FF0000"
            backgroundColor="#FF00001A"
            icon="arrow_upward"
          >
          </fc-data-card-v2>
          <fc-data-card-v2
            [label]="'STORAGE_MOVEMENTS_REPORT.TYPES.CARDS.TRANSFER' | translate"
            [value]="movementsByType.transferCount"
            [loading]="isLoading"
            color="#808080"
            backgroundColor="#8080801A"
            icon="swap_vert"
          >
          </fc-data-card-v2>
        </div>
      </div>

      <div class="content__card" *ngIf="filterForm.value.product">
        <div class="content__card__header">
          <span class="content__card__header__title">
            {{ 'STORAGE_MOVEMENTS_REPORT.PRODUCTS_BY_STORAGE.TITLE' | translate }}
          </span>
        </div>
        <div class="content__card__content">
          <pie-chart [results]="productByStorage" [isLoading]="isLoading" legendPosition="right" [view]="[270, 270]">
          </pie-chart>
        </div>
      </div>

      <div class="content__card" *ngIf="filterForm.value.product">
        <div class="content__card__header line-chart-header">
          <span class="content__card__header__title">
            {{ 'STORAGE_MOVEMENTS_REPORT.STORAGE_MOVEMENTS_BY_DAY.TITLE' | translate }}
          </span>
        </div>

        <div class="content__card__content line-chart-section">
          <div *ngIf="!hasAccountStorageMovementsByDayData && !isLoading">
            <p>{{ 'STORAGE_MOVEMENTS_REPORT.STORAGE_MOVEMENTS_BY_DAY.NO_DATA' | translate }}</p>
          </div>
          <line-chart
            *ngIf="hasAccountStorageMovementsByDayData"
            [results]="movementsByDayTimeline"
            [isLoading]="isLoading"
            [xAxis]="true"
            [yScaleMin]="0"
            [isDateFormat]="true"
          >
          </line-chart>
        </div>
        <div class="storage-movement-list__wrapper">
          <div class="storage-movement-list" *ngFor="let storageMovement of movements; let index = index">
            <storage-movement-card
              class=""
              [storageMovement]="storageMovement"
              [previousDate]="movements[index - 1]?.createdAt"
            ></storage-movement-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
